import { type ClassValue, clsx } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

const configuredApiUrl = import.meta.env?.VITE_API_URL?.trim();

export const API_URL =
  configuredApiUrl && configuredApiUrl.length > 0
    ? configuredApiUrl
    : import.meta.env?.DEV
      ? "http://localhost:8787"
      : typeof window !== "undefined"
        ? window.location.origin
        : "https://admin.misstees.ca";
